import { addMinutes, parseISO } from "date-fns";
import moment from "moment";
import React from "react";
import { DateObject, Calendar as MultiCalendar } from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";


import "../../../styles/Calendar.css";


import defaultImage from "../../../assets/defaultImage.svg";
import greenlocation from "../../../assets/greenlocation.svg";
import greenprice from "../../../assets/greenprice.svg";
import greentime from "../../../assets/greentime.svg";
import loader from "../../../assets/loader.svg";
import progressdone from "../../../assets/progressdone.svg";
import successfullclass from "../../../assets/successfullclass.png";
import { TwButton } from "../../../components/tailwind";
import { minutesToDuration } from "../../../helpers";
import { useToast } from "../../../provider/ToastProvider";
import { useTranslation } from "react-i18next";

export default function ReviewPublishTab({
  formValues,
  formScheduleValues,
  handleFormValueChange,
  setFormValues,
  setTabCurrentState,
  dataSaveProgress,
  defaultDataSaveProgress = { defaultDataSaveProgress },
  setDataSaveProgress = { setDataSaveProgress }
}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const navigate = useNavigate();
  const [courseDates, setCourseDates] = React.useState([new Date()]);

  const getDatesBetween = (startDate, endDate, includeEndDate) => {
    const dates = [];
    const currentDate = startDate;
    while (currentDate < endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    if (includeEndDate) dates.push(endDate);
    return dates;
  };

  let start_date = new Date();
  let end_date = new Date();
  const [selectedStartDate, setSelectedStartDate] = React.useState(moment());
  const [selectedEndDate, setSelectedEndDate] = React.useState(moment());

  React.useEffect(() => {
    (async () => {
      /* const date = new Date(selectedDate).toISOString();
      const allEvents = {  };
        let allEventDates = [];
        const dateFormat = "yyyy-MM-dd";
        const eventDatesRange = { from: "", to: "" };
        const eventKeys = Object.keys(allEvents);
        const startDate = parse(eventKeys[0], dateFormat, new Date());
        const endDate = parse(
          eventKeys[eventKeys.length - 1],
          dateFormat,
          new Date()
        );
        eventDatesRange.from = startDate;
        eventDatesRange.to = endDate;
        eventKeys.forEach((key) => {
          if (allEvents[key].length > 0) {
            const parsedDate = parse(key, dateFormat, new Date());
            allEventDates.push(parsedDate);
          }
        });
        setEventDatesRange({ ...eventDatesRange });
        setEventDates([...allEventDates]); */

      const { daysInWeek, startDate, endBy, timing, recurrenceType } = formScheduleValues;


      let time = formValues.duration;
      const { mins, hours } = minutesToDuration(time);
      const minutes = (mins) ? mins : 0;

      start_date = moment(moment(startDate).format("MM/DD/YYYY") + " " + timing);
      end_date = moment(moment(endBy).format("MM/DD/YYYY") + " " + timing).add({
        hour: hours,
        minute: minutes,
        seconds: 0,
      });
      setSelectedStartDate(moment(moment(startDate).format("MM/DD/YYYY") + " " + timing));
      setSelectedEndDate(moment(moment(endBy).format("MM/DD/YYYY") + " " + timing).add({
        hour: hours,
        minute: minutes,
        seconds: 0,
      }));
      let mapDays = daysInWeek ? daysInWeek.map((day) => parseISO((day instanceof Date) ? day.toISOString() : day)) : [];
      if (formScheduleValues.recurrenceType === "weekly") {
        mapDays = [];
        var currDate = start_date.startOf('day');
        var lastDate = end_date.startOf('day');
        while (currDate.isSameOrBefore(lastDate)) {
          if (formScheduleValues.selectedDays.indexOf(currDate.day()) > -1) {
            mapDays.push(currDate.toDate());
          }
          currDate.add(1, 'days');
        }
      }
      setCourseDates([...mapDays]);
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const parsedStartDate = parseISO((formScheduleValues.startDate instanceof Date) ? formScheduleValues.startDate.toISOString() : formScheduleValues.startDate);
  // setCourseStartDate(parsedStartDate);

  const endTime = addMinutes(parsedStartDate, formValues.duration);

  return (
    <div className={"flex flex-col gap-6 py-6 sm:px-8 max-w-4xl"}>
      <div className={"flex flex-col gap-4"}>
        <div className={"w-full h-64 flex justify-center sm:justify-start"}>
          {formValues.photo ? (
            <img
              className={
                // "w-full h-[225px] object-cover object-fill rounded-2xl"
                "h-64 rounded-2xl"
              }
              src={formValues.photo}
              alt={""}
            />
          ) : (<img
            className={
              "w-full h-64 object-cover rounded-2xl"
            }
            src={defaultImage}
            alt={""}
          />)}
        </div>
        <div className={"flex flex-col gap-4"}>
          <h2 className={"font-bold text-xl sm:text-3xl"}>
            {formValues.eventName}
          </h2>
          <p className={"text-sm sm:text-base"}>{formValues.tagLine}</p>
        </div>
      </div>

      {dataSaveProgress.isStartSubmiting === false ? (
        <>
          <div className="p-5 border-2 border-bright-gray rounded-lg">
            <h4 className={"font-bold text-xl"}>{t("myEvents.eventScheduleDates")}</h4>
            <div className={`flex flex-col sm:flex-row gap-5 w-full pt-5`}>
              <div className="">
                <MultiCalendar
                  className="bookzy-calendar preview px-2.5 py-1"
                  currentDate={new DateObject(formScheduleValues.startDate)}
                  value={courseDates}
                  weekDays={["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
                  readOnly
                  mapDays={({
                    date,
                    today,
                    selectedDate,
                    currentMonth,
                    isSameDate,
                  }) => {
                    let props = {};

                    // const dateTransformed = date.toDate();
                    const dateTransformed = moment(date.toDate()).format("MM/DD/YYYY");
                    const selectedDatesTransformed = selectedDate.map(
                      // (day) => day.toDate()
                      (day) => moment(day.toDate()).format("MM/DD/YYYY")
                    );
                    if (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(today).format("MM/DD/YYYY"))) {
                      props.className = "default-current-date";
                    }

                    if (selectedDatesTransformed.indexOf(dateTransformed) > -1) {
                      props.className = "selected-date";
                    }

                    return props;
                  }}
                />
              </div>
              <div className="flex flex-auto flex-col gap-6 justify-center items-center ">
                <div className="flex justify-center items-center w-4/5">
                  <div className="flex-none">
                    <img
                      className={""}
                      src={greentime}
                      alt={""}
                    />
                  </div>
                  <div className="flex-1 pl-2">
                    <div className="text-gray-500 text-sm">{t("myEvents.time")} </div>
                    <div className="text-black text-base">
                      {formScheduleValues.startDate ? selectedStartDate.format("HH:mm") + " - " + selectedEndDate.format("HH:mm") : ""}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center w-4/5">
                  <div className="flex-none">
                    <img
                      className={""}
                      src={greenlocation}
                      alt={""}
                    />
                  </div>
                  <div className="flex-1 pl-2">
                    <div className="text-gray-500 text-sm">{t("myEvents.where")} </div>
                    <div className="text-black text-base">
                      <p>{formScheduleValues && formScheduleValues.location ? formScheduleValues.location.addressName : ""}</p>
                      <p>{formScheduleValues && formScheduleValues.location ? formScheduleValues.location.address : ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-5 border-2 border-bright-gray rounded-lg">
            <h4 className={"font-bold text-xl mb-2"}>{t("myEvents.aboutThisEvent")}</h4>
            <p dangerouslySetInnerHTML={{ __html: formValues.classDescription }}></p>
            {/* <h4 className={"font-bold text-xl mt-4"}>What to carry</h4>
            <p>{formValues.whatToCarry}</p> */}
          </div>
          <div className="flex flex-col gap-4 p-5 border-2 border-bright-gray rounded-lg">
            <div className={"flex gap-2 items-center w-full"}>
              <div className={`items-left w-full font-bold text-base sm:text-xl`}>
                {t("myEvents.tickets")}
              </div>
              <div className="flex justify-end mt-5 w-full">

              </div>
            </div>
            <div className="overflow-x-auto">
              <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
                <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-form">
                      <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          {t("myEvents.ticketType")}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          {t("myEvents.capacity")}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          {t("myEvents.price")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {(formValues.eventPricingList.length > 0 ? formValues.eventPricingList.map((row, i) => (
                        <React.Fragment key={i}>
                        <tr>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center">
                            {row.ticketType}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold"><div>{row.capacity}</div></td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                            <div>
                              €{row.amount}
                            </div>
                          </td>
                        </tr>
                        {row.includedAddons && row.includedAddons.length > 0 && (
                          <tr>
                            <td colSpan={3} className="pl-8 pr-4 pb-3 text-xs text-gray-500">
                              <span className="font-semibold">Includes:</span>{" "}
                              {row.includedAddons.map((a, ai) => (
                                <span key={ai}>
                                  {a.qtyPerTicket} x {a.addonName}
                                  {a.dietaryEnabled && a.dietaryOptions?.length > 0 && (
                                    <span className="text-gray-400"> (dietary: {a.dietaryOptions.join(", ")})</span>
                                  )}
                                  {ai < row.includedAddons.length - 1 ? ", " : ""}
                                </span>
                              ))}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      )) : (
                        <tr>
                          <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                            {t("myEvents.noTicketsCreated")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {false && (<>
              <div className="flex">
                <div className="flex-none">
                  <img
                    className={""}
                    src={greenprice}
                    alt={""}
                  />
                </div>
                <div className="flex-1 pl-2">
                  <div>{t("myEvents.price")}</div>
                  <div>
                    €{formValues.eventPricingList.length ? formValues.eventPricingList[0].amount : 0}
                    {formValues.eventPricingList.length > 1 ? " -- €" + formValues.eventPricingList[formValues.eventPricingList.length - 1].amount + ` ${t("myEvents.multipleTickets")}` : ""}</div>
                </div>
              </div>
              <div
                className="p-2 sm:p-4 mt-2 bg-list-hover rounded-2xl overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="">
                    <tr className="text-center">
                      <th scope="col" className="w-1/3 py-3.5 pl-4 pr-3 text-center text-base font-extrabold text-gray-900 sm:pl-6 truncate">
                        {t("myEvents.ticketType")}
                      </th>
                      <th scope="col" className="w-1/3 px-3 py-3.5 text-center text-base font-extrabold text-gray-900 truncate">
                        {t("myEvents.capacity")}
                      </th>
                      <th scope="col" className="w-1/3 px-3 py-3.5 text-center text-base font-extrabold text-gray-900 truncate">
                        {t("myEvents.price")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y-8 !border-y-0 divide-list-hover ">
                    {formValues.eventPricingList && formValues.eventPricingList.map((row, i) => (
                      <tr key={i} className="">
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-l-2xl"><div>{row.ticketType}</div></td>
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base"><div>{row.capacity}</div></td>
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-r-2xl"><div>{row.amount}</div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>)}
          </div>
          <div className="flex flex-col gap-4 p-5 border-2 border-bright-gray rounded-lg">
            <div className={"flex gap-2 items-center w-full"}>
              <div className={`items-left w-full font-bold text-base sm:text-xl`}>
                {t("myEvents.addons")}
              </div>
              <div className="flex justify-end mt-5 w-full">

              </div>
            </div>

            <div className="overflow-x-auto">
              <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
                <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-form">
                      <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 truncate">
                          {t("myEvents.addonName")}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                          {t("myEvents.addonType")}
                        </th>
                        {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                          {t("myEvents.qtyPerTicket")}
                        </th> */}
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                          {t("myEvents.priceOnline")}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                          {t("myEvents.priceAtVenue")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {(formValues.addonsPricingList.length > 0 ? formValues.addonsPricingList.map((row, i) => (
                        <tr key={i}>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center">
                            {row.addonName}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                            {row.addonType.replace("_", " ").toLowerCase().replace(/\b[a-z]/g, function (letter) {
                              return letter.toUpperCase();
                            })}
                          </td>
                          {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">{row.maxQtyPerTicket}</td> */}
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">€{row.amountForTicket}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">€{row.amountForLocation}</td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan={5} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                            {t("myEvents.noAddonsCreated")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {false && (<>
              <div className="flex">
                <div className="flex-none">
                  <img
                    className={""}
                    src={greenprice}
                    alt={""}
                  />
                </div>
                <div className="flex-1 pl-2">
                  <div>Addons</div>
                  <div>
                    €{formValues.addonsPricingList.length ? formValues.addonsPricingList[0].amountForTicket : 0}
                    {formValues.addonsPricingList.length > 1 ? " -- €" + formValues.addonsPricingList[formValues.addonsPricingList.length - 1].amountForTicket + " (Multiple Addons)" : ""}</div>
                </div>
              </div>
              <div
                className="p-2 sm:p-4 mt-2 bg-list-hover rounded-2xl overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="">
                    <tr className="text-center">
                      <th scope="col" className="w-1/3 py-3.5 pl-4 pr-3 text-center text-base font-extrabold text-gray-900 sm:pl-6 truncate">
                        {t("myEvents.addonName")}
                      </th>
                      <th scope="col" className="w-1/3 px-3 py-3.5 text-center text-base font-extrabold text-gray-900 truncate">
                        {t("myEvents.qtyPerTicket")}
                      </th>
                      <th scope="col" className="w-1/3 px-3 py-3.5 text-center text-base font-extrabold text-gray-900 truncate">
                        {t("myEvents.priceOnline")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y-8 !border-y-0 divide-list-hover ">
                    {formValues.addonsPricingList && formValues.addonsPricingList.map((row, i) => (
                      <tr key={i} className="">
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-l-2xl"><div>{row.addonName}</div></td>
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base"><div>{row.maxQtyPerTicket}</div></td>
                        <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-r-2xl"><div>{row.amountForTicket}</div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>)}
          </div>
          <div className="p-5 border-2 border-bright-gray rounded-lg">
            <h4 className={"font-bold text-xl "}>{formValues.inviteCodeOnlyBooking ? t("myEvents.privateEventStatus") : t("myEvents.publicEventStatus")}</h4>
            {formValues.inviteCodeOnlyBooking ? (<>
              <p className={"text-sm text-gray-500"}>
                {t("myEvents.privateEventMsg1")} <br></br>
                {t("myEvents.privateEventMsg2")}
              </p>
            </>) : (
              <p className={"text-sm text-gray-500"}>
                {t("myEvents.eventCanBookedByAnybody")}
              </p>
            )}

            <h4 className={"font-bold text-xl mt-4"}>{t("myEvents.cancellationPolicyTitle")}</h4>
            <p className={"text-sm text-gray-500"}>
              {/* Cancellation is free in case booking is cancelled <span className="font-semibold">{formValues.cancellationPeriod}</span> before start of the class. */}
              {formValues.freeCancellation ? (
                <p className={"font-light text-base"}>
                  {/* Cancelation is free in case booking is cancelled{" "}
                      <span className={"font-bold"}>
                        {formValues.cancellationPeriod}
                      </span>{" "}
                      before start of the class. */}
                  {t("myEvents.cancellationPolicyMsg1")} <span className={"font-bold"}>€{formValues?.cancellationCharge || 0}</span> {t("myEvents.cancellationPolicyMsg2")}
                  {" "}
                  <span className={"font-bold"}>
                    {formValues.cancellationPeriod}
                  </span>{" "} {t("myEvents.cancellationPolicyMsg3")}
                </p>
              ) : (
                <p className={"font-light text-base"}>
                  {t("myEvents.freeCancelationNotAvailable")}
                </p>
              )}
            </p>

            <h4 className={"font-bold text-xl mt-4"}>{t("myEvents.orderLimit")}</h4>
            {formValues?.orderLimit && formValues?.maxTicketsPerOrder != undefined && formValues?.maxTicketsPerOrder !== 1000 ? (
              <p className={"text-sm text-gray-500"}>
                {t("myEvents.maxTicketsPerOrderMsg1")} <span className="font-bold">{formValues?.maxTicketsPerOrder}</span> {t("myEvents.maxTicketsPerOrderMsg2")}
              </p>
            ) : (
              <p className={"text-sm text-gray-500"}>
                {t("myEvents.noLimitInSingleOrder")}
              </p>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col justify-center items-center w-full">
            <div className="flex justify-center items-center w-4/5 py-3">
              <div className="flex-1 pl-2 text-gray-500">
                {t("myEvents.createdEventStep1")}
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.createEvent) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            <div className="flex justify-center items-center w-4/5 py-3">
              <div className="flex-1 pl-2 text-gray-500">
                {t("myEvents.createdEventStep2")}
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.createPricing) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            <div className="flex justify-center items-center w-4/5 py-3">
              <div className="flex-1 pl-2 text-gray-500">
                {t("myEvents.createdEventStep3")}
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.createSchedule) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            <div className="flex justify-center items-center w-4/5 py-3">
              <div className="flex-1 pl-2 text-gray-500">
                {t("myEvents.savingInDraft")}
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.changePublishStatus) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            <div className="flex justify-center items-center w-4/5 py-3">
              <div className="flex-1 pl-2 text-gray-500">
                {t("myEvents.creatingBookingLink")}
              </div>
              <div className="flex-none">
                <img
                  className={""}
                  src={(dataSaveProgress.creatingBookingLink) ? progressdone : loader}
                  alt={""}
                />
              </div>
            </div>
            {dataSaveProgress.creatingBookingLink === true ? (
              <div className="flex flex-col justify-center items-center w-full mt-5">

                <div className="flex flex-col justify-center items-center text-center">
                  <img
                    className={"w-40"}
                    src={successfullclass}
                    alt={""}
                  />
                  <div className={"text-2xl font-bold"}>
                    {t("myEvents.createdEventSucc1")}<br></br>
                    {t("myEvents.createdEventSucc2")}
                  </div>
                  {/* <div className={"text-[#000000B2] text-lgxl my-3"}>
                    {t("myEvents.shareTheLinkBelowMsg")}
                  </div> */}

                </div>
                {/* <div className="flex justify-center items-center w-3/4 mt-5 bg-list-hover rounded-2xl border border-gray-300">
                  <div className="max-h-6 flex-1 pl-2 text-black my-0 mx-5 truncate cursor-pointer">
                    {dataSaveProgress.bookingLink}
                  </div>
                  <div className="flex flex-none bg-primary py-2 px-5 rounded-e-2xl">
                    <button className="cursor-pointer" type="button" underline="none" onClick={() => {
                      navigator.clipboard.writeText(dataSaveProgress.bookingLink);
                      addSuccessToast(t("myEvents.copied"));
                    }}>
                      <img
                        className={"w-5"}
                        src={copyOrange}
                        alt={""}
                      />
                    </button>
                    <button className="cursor-pointer" type="button" underline="none" target="_blank"onClick={() => {
                      window.open(dataSaveProgress.bookingLink, '_blank');
                    }}>
                      <img
                        className={"w-5 ml-3 mr-5"}
                        src={shareOrange}
                        alt={""}
                      />
                    </button>
                  </div>
                </div> */}
                <div className="flex justify-center items-center gap-4 w-full mt-16">
                  <TwButton
                    variant={"secondary-outline"}
                    onClick={() => {
                      navigate("/myevents/new", {
                        state: null,
                        replace: true
                      });
                      window.location.href = "/myevents/new";
                      // window.location.reload();
                    }}
                  >
                    {t("myEvents.addAnotherEvent")}
                  </TwButton>
                  <TwButton
                    variant={"secondary"}
                    onClick={(e) => {
                      // navigate("/myevents", { replace: true });
                      navigate("/myschedule", { replace: true });
                    }}
                  >
                    {t("myEvents.gotoMyEvents")}
                  </TwButton>
                </div>
              </div>
            ) : ""}
          </div>
        </>
      )}
    </div>
  );
}
